var RESET_MESSAGES = 'RESET_MESSAGES';
var FETCH_INITIAL_MESSAGES_START = 'FETCH_INITIAL_MESSAGES_START';
var FETCH_INITIAL_MESSAGES_SUCCESS = 'FETCH_INITIAL_MESSAGES_SUCCESS';
var FETCH_INITIAL_MESSAGES_FAILURE = 'FETCH_INITIAL_MESSAGES_FAILURE';
var FETCH_PREV_MESSAGES_SUCCESS = 'FETCH_PREV_MESSAGES_SUCCESS';
var FETCH_PREV_MESSAGES_FAILURE = 'FETCH_PREV_MESSAGES_FAILURE';
var FETCH_NEXT_MESSAGES_SUCCESS = 'FETCH_NEXT_MESSAGES_SUCCESS';
var FETCH_NEXT_MESSAGES_FAILURE = 'FETCH_NEXT_MESSAGES_FAILURE';
var SEND_MESSAGE_START = 'SEND_MESSAGE_START';
var SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
var SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';
var RESEND_MESSAGE_START = 'RESEND_MESSAGE_START';
var ON_MESSAGE_RECEIVED = 'ON_MESSAGE_RECEIVED';
var ON_MESSAGE_UPDATED = 'ON_MESSAGE_UPDATED';
var ON_MESSAGE_THREAD_INFO_UPDATED = 'ON_MESSAGE_THREAD_INFO_UPDATED';
var ON_MESSAGE_DELETED = 'ON_MESSAGE_DELETED';
var ON_MESSAGE_DELETED_BY_REQ_ID = 'ON_MESSAGE_DELETED_BY_REQ_ID';
var SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL';
var SET_CHANNEL_INVALID = 'SET_CHANNEL_INVALID';
var MARK_AS_READ = 'MARK_AS_READ';
var ON_REACTION_UPDATED = 'ON_REACTION_UPDATED';
var SET_EMOJI_CONTAINER = 'SET_EMOJI_CONTAINER';
var MESSAGE_LIST_PARAMS_CHANGED = 'MESSAGE_LIST_PARAMS_CHANGED';
var ON_FILE_INFO_UPLOADED = 'ON_FILE_INFO_UPLOADED';
var ON_TYPING_STATUS_UPDATED = 'ON_TYPING_STATUS_UPDATED';

var channelActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_INITIAL_MESSAGES_FAILURE: FETCH_INITIAL_MESSAGES_FAILURE,
  FETCH_INITIAL_MESSAGES_START: FETCH_INITIAL_MESSAGES_START,
  FETCH_INITIAL_MESSAGES_SUCCESS: FETCH_INITIAL_MESSAGES_SUCCESS,
  FETCH_NEXT_MESSAGES_FAILURE: FETCH_NEXT_MESSAGES_FAILURE,
  FETCH_NEXT_MESSAGES_SUCCESS: FETCH_NEXT_MESSAGES_SUCCESS,
  FETCH_PREV_MESSAGES_FAILURE: FETCH_PREV_MESSAGES_FAILURE,
  FETCH_PREV_MESSAGES_SUCCESS: FETCH_PREV_MESSAGES_SUCCESS,
  MARK_AS_READ: MARK_AS_READ,
  MESSAGE_LIST_PARAMS_CHANGED: MESSAGE_LIST_PARAMS_CHANGED,
  ON_FILE_INFO_UPLOADED: ON_FILE_INFO_UPLOADED,
  ON_MESSAGE_DELETED: ON_MESSAGE_DELETED,
  ON_MESSAGE_DELETED_BY_REQ_ID: ON_MESSAGE_DELETED_BY_REQ_ID,
  ON_MESSAGE_RECEIVED: ON_MESSAGE_RECEIVED,
  ON_MESSAGE_THREAD_INFO_UPDATED: ON_MESSAGE_THREAD_INFO_UPDATED,
  ON_MESSAGE_UPDATED: ON_MESSAGE_UPDATED,
  ON_REACTION_UPDATED: ON_REACTION_UPDATED,
  ON_TYPING_STATUS_UPDATED: ON_TYPING_STATUS_UPDATED,
  RESEND_MESSAGE_START: RESEND_MESSAGE_START,
  RESET_MESSAGES: RESET_MESSAGES,
  SEND_MESSAGE_FAILURE: SEND_MESSAGE_FAILURE,
  SEND_MESSAGE_START: SEND_MESSAGE_START,
  SEND_MESSAGE_SUCCESS: SEND_MESSAGE_SUCCESS,
  SET_CHANNEL_INVALID: SET_CHANNEL_INVALID,
  SET_CURRENT_CHANNEL: SET_CURRENT_CHANNEL,
  SET_EMOJI_CONTAINER: SET_EMOJI_CONTAINER
});

export { FETCH_INITIAL_MESSAGES_START as F, MESSAGE_LIST_PARAMS_CHANGED as M, ON_MESSAGE_RECEIVED as O, RESET_MESSAGES as R, SEND_MESSAGE_START as S, FETCH_INITIAL_MESSAGES_SUCCESS as a, FETCH_INITIAL_MESSAGES_FAILURE as b, FETCH_PREV_MESSAGES_SUCCESS as c, FETCH_NEXT_MESSAGES_SUCCESS as d, FETCH_PREV_MESSAGES_FAILURE as e, FETCH_NEXT_MESSAGES_FAILURE as f, SEND_MESSAGE_SUCCESS as g, SEND_MESSAGE_FAILURE as h, SET_CURRENT_CHANNEL as i, SET_CHANNEL_INVALID as j, ON_MESSAGE_UPDATED as k, ON_MESSAGE_THREAD_INFO_UPDATED as l, RESEND_MESSAGE_START as m, MARK_AS_READ as n, ON_MESSAGE_DELETED as o, ON_MESSAGE_DELETED_BY_REQ_ID as p, SET_EMOJI_CONTAINER as q, ON_REACTION_UPDATED as r, ON_FILE_INFO_UPLOADED as s, ON_TYPING_STATUS_UPDATED as t, channelActions as u };
//# sourceMappingURL=bundle-Qobh-hS4.js.map
